const GoalsLoadingState: React.FC<{ isLoading: boolean, goalsExist: boolean, t: any }> = ({ isLoading, goalsExist, t }) => (
    <div className="flex justify-center py-1">
        {isLoading ? (
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        ) : !goalsExist ? (
            <div className="text-gray-500 dark:text-gray-400">
                {t('goals.emptyState')}
            </div>
        ) : null}
    </div>
)

export default GoalsLoadingState;